/* Juni product-view tracking for buy boxes outside product pages.
   See `track_views` in snippets/juni-buybox.liquid.

   Product pages get GA4 view_item (Google & YouTube app) and Klaviyo
   Viewed Product (Klaviyo app embed) for free; a page like /pages/stickpacks
   sends neither, so its viewers never enter Browse Abandonment. This sends
   both for the selection on screen: on load, when a shop tab is shown
   (jn:panel-shown from juni-shop) and when a size pill changes.

   GA4 goes through the gtag the Google & YouTube app already runs on the
   page, so it lands in the same client/session, with the app's item_id
   format (shopify_US_<productId>_<variantId>). send_to is GA4 only, so no
   Google Ads conversion actions fire from here. */
(function () {
  if (window.jnTrack) return;
  var GA4 = 'G-ZTB2M6WPHW';
  var last = null;

  function allowed(kind) {
    var p = window.Shopify && Shopify.customerPrivacy;
    if (!p) return true;
    try {
      return kind === 'ga' ? p.analyticsProcessingAllowed() : p.marketingAllowed();
    } catch (e) { return true; }
  }

  function money(cents) { return '$' + (Number(cents) / 100).toFixed(2); }

  // The app's gtag config can arrive after this script; an event queued
  // before `config` would go nowhere, so wait for the GA4 tag to register.
  function whenGa(fn, tries) {
    tries = tries || 0;
    var ready = window.gtag && window.google_tag_manager && window.google_tag_manager[GA4];
    if (ready) return fn();
    if (tries < 40) setTimeout(function () { whenGa(fn, tries + 1); }, 250);
  }

  function send(it) {
    var price = Number(it.price) / 100;
    var img = it.img && it.img.indexOf('//') === 0 ? 'https:' + it.img : it.img;

    if (allowed('ga')) whenGa(function () {
      gtag('event', 'view_item', {
        send_to: GA4,
        currency: 'USD',
        value: price,
        items: [{
          item_id: 'shopify_US_' + it.pid + '_' + it.vid,
          item_name: it.name,
          item_variant: it.variant,
          item_brand: it.brand,
          item_category: it.type,
          price: price,
          quantity: 1
        }]
      });
    });

    if (allowed('mk')) {
      // Same property names the Klaviyo app embed sends on product pages,
      // so Browse Abandonment's dynamic blocks and filters work unchanged.
      // `Page` is extra: it tells these apart from product-page views.
      var k = window.klaviyo = window.klaviyo || [];
      var props = {
        Name: it.name,
        ProductID: it.pid,
        Categories: it.cats || [],
        ImageURL: img,
        URL: it.url,
        Brand: it.brand,
        Price: money(it.price),
        CompareAtPrice: money(it.compare || 0),
        Value: price.toFixed(2),
        Page: location.pathname
      };
      k.push(['track', 'Viewed Product', props]);
      k.push(['trackViewedItem', {
        Title: it.name, ItemId: it.pid, Categories: it.cats || [], ImageUrl: img, Url: it.url,
        Metadata: { Brand: it.brand, Price: money(it.price), CompareAtPrice: money(it.compare || 0) }
      }]);
    }
  }

  function visible(el) { return !!(el && el.offsetParent !== null); }

  function fromForm(form) {
    if (!form || form.dataset.trackViews !== 'true' || !visible(form)) return;
    var pill = form.querySelector('.jn-bb__pills input:checked');
    if (!pill || !pill.dataset.item) return;
    var it;
    try { it = JSON.parse(pill.dataset.item); } catch (e) { return; }
    if (String(it.vid) === last) return; // same selection, already sent
    last = String(it.vid);
    send(it);
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-bb][data-track-views="true"]').forEach(fromForm);
  }

  document.addEventListener('jn:panel-shown', function (e) { scan(e.detail); });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('.jn-bb__pills input')) fromForm(e.target.form || e.target.closest('[data-bb]'));
  });

  window.jnTrack = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})();
